import { render, staticRenderFns } from "./TaskServiceConfiguration.vue?vue&type=template&id=58a7d26a&scoped=true&"
import script from "./TaskServiceConfiguration.vue?vue&type=script&lang=ts&"
export * from "./TaskServiceConfiguration.vue?vue&type=script&lang=ts&"
import style0 from "./TaskServiceConfiguration.vue?vue&type=style&index=0&id=58a7d26a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58a7d26a",
  null
  
)

export default component.exports